"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIsLoadingAction = exports.SET_IS_LOADING = exports.addProductsAction = exports.ADD_PRODUCTS = void 0;
var actions_1 = require("../utils/actions");
var prefix = 'EJS_PRODUCTS_';
exports.ADD_PRODUCTS = "".concat(prefix, "ADD_PRODUCTS");
exports.addProductsAction = (0, actions_1.actionCreator)(exports.ADD_PRODUCTS);
exports.SET_IS_LOADING = "".concat(prefix, "SET_IS_LOADING");
exports.setIsLoadingAction = (0, actions_1.actionCreator)(exports.SET_IS_LOADING);
